import { GA_EVENTS } from "../common/gaEventConstants";
import { doSSOLogout } from "../firebase/ssoAuthenticate";
import GaEventHelper from "./ga-event-helper";
import { logoutService } from "../services/SessionService";
import { deleteCookie, getCookie } from "../utils/utils";

export const logoutHandler = async (countryCode, userDetails, history) => {
    GaEventHelper.gaCommonEvent({userDetails: userDetails, screen_name:history?.location?.pathname?.replace('/',''),event: GA_EVENTS.logout })
    logoutService(countryCode);
    if (getCookie("isSSOLogin") || getCookie("isMFALogin")) {
      await doSSOLogout();
      getCookie("idToken") && deleteCookie("idToken");
      getCookie("refreshToken") && deleteCookie("refreshToken");
      getCookie("isSSOLogin") && deleteCookie("isSSOLogin");
      getCookie("isMFALogin") && deleteCookie("isMFALogin");
      getCookie("countryCode") && deleteCookie("countryCode")
      localStorage.removeItem("countryCode");
      localStorage.removeItem("isIndonesia");
      localStorage.removeItem("isIndonesiaIc");
      localStorage.removeItem("isVietnam");
      localStorage.removeItem("isPhilipines");
      localStorage.removeItem("isThailand");
      localStorage.removeItem("isPakistan");
      localStorage.removeItem("isCambodia");
      localStorage.removeItem("isLaos");
      localStorage.removeItem("isMalaysia");
      localStorage.removeItem("adminAccess");
      localStorage.removeItem("selectedDropdownLabel");
      localStorage.removeItem("email");
      localStorage.removeItem("isSSOLogin");
      localStorage.removeItem("loginType");
      localStorage.removeItem("UUID");
      localStorage.removeItem("localId");
      history.push("/login");
    }
  };